export default {
  props: {
    chip: {
      type: String,
      default: ''
    },
    /**
     * 传入的数据为固定格式
     * {
     *    vertical: []
     *    horizontal: []
     * }
     */
    data: {
      type: Object,
      default() {
        return {
          vertical: [],
          horizontal: [],
        }
      }
    },
    current: {
      type: Object | Number,
      default() {
        return {
          value: ''
        }
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/pageComponents/mixins.js